export const MenusArchives = () => {
    const datas = [
        { name: 'Historique', href: '/historique' },
        { name: 'Archives des attractions', href: '/archives-des-attractions' },
        { name: 'Festivals Disney', href: '/festivals-disney' },
    ];
    return datas;
}